import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import { SYS_USER_LOGIN, SYS_USER_LOGIN_BY_MOBILE } from '@/api/sys.user.js';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dispatch, _ref2, _ref2$username, username, _ref2$password, password, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = _ref.dispatch;
                _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$username = _ref2.username, username = _ref2$username === void 0 ? '' : _ref2$username, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password;
                _context.next = 4;
                return SYS_USER_LOGIN({
                  username: username,
                  password: password,
                  loginType: 'password'
                });

              case 4:
                res = _context.sent;
                // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                // 整个系统依赖这两个数据进行校验和存储
                // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                // token 代表用户当前登录状态 建议在网络请求中携带 token
                // 如有必要 token 需要定时更新，默认保存一天
                util.cookies.set('uuid', res.token);
                util.cookies.set('token', res.token); // 设置 vuex 用户信息

                _context.next = 9;
                return dispatch('d2admin/user/set', {
                  name: res.nickName
                }, {
                  root: true
                });

              case 9:
                _context.next = 11;
                return dispatch('load');

              case 11:
                return _context.abrupt("return", res);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loginByMobile: function loginByMobile(_ref3) {
      var _arguments2 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var dispatch, _ref4, _ref4$username, username, _ref4$code, code, res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch = _ref3.dispatch;
                _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, _ref4$username = _ref4.username, username = _ref4$username === void 0 ? '' : _ref4$username, _ref4$code = _ref4.code, code = _ref4$code === void 0 ? '' : _ref4$code;
                _context2.next = 4;
                return SYS_USER_LOGIN_BY_MOBILE({
                  username: username,
                  code: code,
                  loginType: 'code'
                });

              case 4:
                res = _context2.sent;
                // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                // 整个系统依赖这两个数据进行校验和存储
                // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                // token 代表用户当前登录状态 建议在网络请求中携带 token
                // 如有必要 token 需要定时更新，默认保存一天
                util.cookies.set('uuid', res.token);
                util.cookies.set('token', res.token); // 设置 vuex 用户信息

                _context2.next = 9;
                return dispatch('d2admin/user/set', {
                  name: res.nickName
                }, {
                  root: true
                });

              case 9:
                _context2.next = 11;
                return dispatch('load');

              case 11:
                return _context2.abrupt("return", res);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref5) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$confirm = _ref6.confirm,
          confirm = _ref6$confirm === void 0 ? false : _ref6$confirm;

      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  // 删除cookie
                  util.cookies.remove('token');
                  util.cookies.remove('uuid'); // 清空 vuex 用户信息

                  _context3.next = 4;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 4:
                  // 跳转路由
                  router.push({
                    name: 'login'
                  });

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前用户吗', '退出用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref7) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref7.dispatch;
                _context4.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                _context4.next = 5;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 5:
                _context4.next = 7;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });

              case 7:
                _context4.next = 9;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 9:
                _context4.next = 11;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 11:
                _context4.next = 13;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 13:
                _context4.next = 15;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};